import { PDFViewer } from 'pdfjs-dist/web/pdf_viewer';
import { Position } from '../types/result';

export const getScaled = (
  container: PDFViewer,
  page: { node: HTMLElement; number: number },
  boundingRect: { x1: number; y1: number; x2: number; y2: number }
) => {
  const pageView = container.getPageView(page.number - 1);
  const viewport = pageView.viewport;
  const { width, height } = viewport;

  const coordinates = {
    x1: (boundingRect.x1 - page.node.offsetLeft) / width,
    y1: (boundingRect.y1 - page.node.offsetTop) / height,
    x2: (boundingRect.x2 - page.node.offsetLeft) / width,
    y2: (boundingRect.y2 - page.node.offsetTop) / height,
  };

  return coordinates;
};

export const scaledPositionToViewport = (container: PDFViewer, position: Position, pageNumber: number) => {
  const viewport = container.getPageView(pageNumber - 1).viewport;

  return {
    position: scaledToViewport(position, viewport),
    pageNumber: pageNumber,
  };
};

export const scaledToViewport = (scaled: Position, viewport: { width: number; height: number }) => {
  const { width, height } = viewport;

  const x1 = width * scaled.x1;
  const y1 = height * scaled.y1;

  const x2 = width * scaled.x2;
  const y2 = height * scaled.y2;

  const scaledToViewport = {
    left: x1,
    top: y1,
    width: x2 - x1,
    height: y2 - y1,
  };

  return scaledToViewport;
};

export const scalePosition = (container: PDFViewer, position: Position, pageNumber: number) => {
  const viewport = container.getPageView(pageNumber - 1).viewport;
  const { width, height } = viewport;

  const coordinates = {
    x1: position.x1 * width,
    y1: position.y1 * height,
    x2: position.x2 * width,
    y2: position.y2 * height,
  };

  return coordinates;
};

export const screenshot = (container: PDFViewer, position: Position, pageNumber: number) => {
  const canvas = container.getPageView(pageNumber - 1).canvas;
  const scaledPosition = scalePosition(container, position, pageNumber);
  return getAreaAsPng(canvas, scaledPosition);
};

export const getAreaAsPng = (canvas: HTMLCanvasElement, position: Position) => {
  const { x1, y1, x2, y2 } = position;
  const width = x2 - x1;
  const height = y2 - y1;

  const newCanvas = document.createElement('canvas');

  if (!(newCanvas instanceof HTMLCanvasElement)) {
    return '';
  }

  newCanvas.width = width;
  newCanvas.height = height;

  const newCanvasContext = newCanvas.getContext('2d');

  if (!newCanvasContext || !canvas) {
    return '';
  }

  const dpr = window.devicePixelRatio;

  newCanvasContext.drawImage(canvas, x1 * dpr, y1 * dpr, width * dpr, height * dpr, 0, 0, width, height);

  return newCanvas.toDataURL('image/png');
};
